<template>
  <span>{{ value }}</span>
</template>
<script>
import BaseColumnRendererMixin from 'vue-cl/renderers/column/BaseColumnRendererMixin';

export default {
  mixins: [ BaseColumnRendererMixin ]
};
</script>
